import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { useFormatMessage, commonCTAs } from 'lib/localization'

export const GENERAL_MODAL = 'GENERAL_MODAL'

/*
 * use this if you just wanna throw a component into a modal. if you want
 * anything in the way of complex behavior out of your modal, it probably
 * deserves its own modal entry
*/

export const GeneralModal = ({ title, component, onRequestClose }) => {
  const fm = useFormatMessage()
  return (
    <ConfirmationDialog
      title={title}
      maxWidth='600px'
      showCancel={false}
      onRequestClose={onRequestClose}
      confirmText={fm(commonCTAs.close)}
      onConfirm={onRequestClose}>
      {component}
    </ConfirmationDialog>
  )
}
